import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://lobfoivjtkmewqhunnry.supabase.co';
const supabaseAnonKey = 'sb_publishable_zDbz86NkA466tHkQBpYvbA_KjKaPsJv';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // Disable the cross-tab navigator lock to prevent
    // "Lock broken by another request with the 'steal' option" errors
    // when multiple tabs or incognito windows are open.
    lock: async (_name, _acquireTimeout, fn) => await fn(),
  },
});

// Tipos para la base de datos
export interface UserRole {
  id: string;
  user_id: string;
  role: 'novagob_team' | 'jury' | 'public';
  created_at: string;
}

export type CategoryType = 'personal' | 'project' | 'benchmark';

export interface Category {
  id: string;
  name: string;
  type: CategoryType;
  description: string | null;
  max_nominations: number;
  current_nominations: number;
  is_open: boolean;
  created_at: string;
  updated_at: string;
}

export interface Nomination {
  id: string;
  category_id: string;
  submitter_email: string;
  submitter_name: string;

  // Campos para personas
  candidate_name?: string;
  candidate_reason?: string;
  candidate_cv_url?: string;
  candidate_social_links?: string;

  // Campos para proyectos
  project_title?: string;
  institution?: string;
  project_summary?: string;
  target_audience?: string;
  innovation_description?: string;
  collaboration_description?: string;
  replicability_description?: string;
  impact_description?: string;
  cost_benefit_description?: string;
  sustainability_description?: string;
  project_url?: string;
  project_social_links?: string;

  // Campos específicos Benchmarking
  benchmark_edicion_categoria?: string;
  benchmark_descripcion_breve?: string;
  benchmark_impacto_sostenido?: string;
  benchmark_elementos_replicables?: string;
  benchmark_administraciones_replicadoras?: string;
  benchmark_mejoras_aprendizajes?: string;
  benchmark_evidencias_enlaces?: string;

  status: 'pending' | 'approved' | 'rejected';
  reviewed_by?: string;
  reviewed_at?: string;
  created_at: string;
  updated_at: string;
  last_modified_by?: string;
  last_modified_at?: string;
}

export interface JuryVote {
  id: string;
  nomination_id: string;
  jury_member_id: string;

  // Criterios para personas
  trayectoria_profesional?: number;
  actividades_destacadas?: number;
  compromiso_difusion?: number;

  // Criterios para proyectos
  creatividad_innovacion?: number;
  impacto_ciudadania?: number;
  transferencia_difusion?: number;
  sostenibilidad?: number;
  cambio_cultura?: number;
  equilibrio_eficacia?: number;
  evaluacion_iniciativa?: number;

  // Criterios específicos Benchmarking
  benchmark_impacto_sostenido?: number;
  benchmark_replicabilidad?: number;
  benchmark_adopcion_referencia?: number;
  benchmark_capacidad_inspirar?: number;

  general_comment?: string;
  created_at: string;
  updated_at: string;
}

export interface PublicVote {
  id: string;
  nomination_id: string;
  voter_id: string;
  category_id: string;
  created_at: string;
}

export interface PlatformConfig {
  id: string;
  jury_voting_enabled: boolean;
  public_voting_enabled: boolean;
  public_voting_start_date?: string;
  public_voting_end_date?: string;
  nominations_editing_enabled: boolean;
  nominations_submission_enabled: boolean;
  /** Lista de correos a los que avisar al recibirse una nueva candidatura */
  new_nomination_notify_emails?: string[];
  updated_at: string;
  updated_by?: string;
}

export interface JuryMember {
  id: string;
  user_id: string;
  category_id: string;
  created_at: string;
}
